export var appendSearchCompleteAddressInfoText = function appendSearchCompleteAddressInfoText(item) {
  var list = [];
  var line_1 = item.line_1,
      line_2 = item.line_2,
      line_3 = item.line_3;

  if (line_1) {
    list.push(line_1);
  }

  if (line_2) {
    list.push(line_2);
  }

  if (line_3) {
    list.push(line_3);
  }

  return list.join(', ');
};